export const tabList = [
  { text: 'My App', code: 'myAppData' },
  { text: 'Vs. Competiters', code: 'competitionData' },
];
